/**
 * Banner de erro persistente de formulário: o 400 fica gravado na página
 * (role=alert, abaixo do submit), em vez de viver só 4s num toast.
 * Uso: <FormError error={formError} onClear={() => setFormError(null)} />
 */
export default function FormError({ error, onClear }: { error: string | null; onClear?: () => void }) {
  if (!error) return null;
  return (
    <div role="alert" className="rounded-lg border border-red-300 bg-red-50 p-3 text-sm text-red-800">
      <div className="flex items-start justify-between gap-3">
        <p className="font-medium min-w-0 break-words">{error}</p>
        {onClear && (
          <button type="button" onClick={onClear} aria-label="Fechar erro"
            className="shrink-0 rounded-lg border border-red-300 px-3 py-1 text-xs font-medium hover:bg-red-100">
            Fechar
          </button>
        )}
      </div>
      {error.toLowerCase().includes('chave') && (
        <p className="mt-2">
          <a href="/painel/configuracoes" className="font-medium underline hover:no-underline">Abrir Configurações → Integrações</a>
        </p>
      )}
    </div>
  );
}